import React from 'react';
import { useNavigate } from 'react-router-dom';

const VerificationSuccess = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    localStorage.removeItem("employeeDetails");
    navigate('/retailerdashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-14 rounded-3xl shadow-2xl text-center w-[600px] h-[450px]">
        <div className="mx-auto mb-8 w-24 h-24 bg-green-100 rounded-[24px] flex items-center justify-center shadow-inner">
          <svg
            className="w-14 h-14 text-green-600"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2 className="text-3xl font-bold text-gray-800">Successfully Verified</h2>
        <p className="text-lg text-gray-600 mt-4">
          Welcome to the driver’s seat. Let’s get things moving!
        </p>
        <button
          onClick={handleContinue}
          className="mt-10 bg-green-600 text-white px-10 py-3 rounded-lg hover:bg-green-800 transition-all duration-300"
        >
          Go To Dashboard
        </button>
      </div>
    </div>
  );
};

export default VerificationSuccess;
